import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "topSellerBadge",
    "sectionTwelveMonth",
    "sectionThreeMonth",
    "sectionPayPerWash"
  ]
  static values = {
    currentSegment: Number
  }

  connect() {
    this.showSection(this.currentSegmentValue);
  }

  handleSegmentChange(event) {
    const segmentValue = parseInt(event.detail.value);
    this.currentSegmentValue = segmentValue
    this.toggleTopSellerBadge();
    this.showSection(segmentValue);
    this.animateSection(segmentValue);
  }

  toggleTopSellerBadge() {
    if(!this.hasTopSellerBadgeTarget) return;

    if (this.currentSegmentValue === 0) {
      this.topSellerBadgeTarget.style.opacity = '0'
      this.topSellerBadgeTarget.style.transform = 'translateY(10px)'
      this.topSellerBadgeTarget.style.display = 'block'

      requestAnimationFrame(() => {
        this.topSellerBadgeTarget.style.opacity = '1'
        this.topSellerBadgeTarget.style.transform = 'translateY(0)'
      })
    } else {
      this.topSellerBadgeTarget.style.opacity = '0'

      setTimeout(() => {
        this.topSellerBadgeTarget.style.display = 'none'
      }, 300)
    }
  }

  showSection(segmentValue) {
    const segment = parseInt(segmentValue)

    this.sectionTwelveMonthTarget.classList.add('hidden')
    this.sectionThreeMonthTarget.classList.add('hidden')
    this.sectionPayPerWashTarget.classList.add('hidden')

    switch(segment) {
      case 0:
        this.sectionTwelveMonthTarget.classList.remove('hidden')
        break;
      case 1:
        this.sectionThreeMonthTarget.classList.remove('hidden')
        break;
      case 2:
        this.sectionPayPerWashTarget.classList.remove('hidden')
        break;
    }
  }

  animateSection(segmentValue) {
    const segment = parseInt(segmentValue)
    let targetSection

    // Use Stimulus targets instead of querySelector
    switch(segment) {
      case 0:
        if (this.hasSectionTwelveMonthTarget) {
          targetSection = this.sectionTwelveMonthTarget
        }
        break
      case 1:
        if (this.hasSectionThreeMonthTarget) {
          targetSection = this.sectionThreeMonthTarget
        }
        break
      case 2:
        if (this.hasSectionPayPerWashTarget) {
          targetSection = this.sectionPayPerWashTarget
        }
        break
    }

    if (!targetSection) return

    // Animate cards in the visible section
    const cards = targetSection.querySelectorAll('.product-card')
    cards.forEach((card, index) => {
      card.style.opacity = '0'
      card.style.transform = 'scale(0.95)'
      card.style.transition = 'opacity 0.3s ease, transform 0.3s ease'

      setTimeout(() => {
        card.style.opacity = '1'
        card.style.transform = 'scale(1)'
      }, 150 * (index + 1))
    })
  }
}